<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Form elements component
 */

 export default {
  page: {
    title: "Manejo seguro de sustancias de químicas",
    meta: [{ name: "sustancias-quimicas", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Style,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },

        {
          text: "Manejo seguro de sustancias de químicas",
          active: true,
        },
      ],
      loading: true,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },
};

</script>

<template>
    <Layout>
        <PageHeader :title="title " />

        <div class="row animated animatedFadeInUp fadeInUp">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <h4 class="header-title">Manejo seguro de sustancias de químicas</h4>
                            </div>
                            <div class="col-6 text-right">
                                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                                  <i class="fas fa-arrow-left"></i>
                                </button>
                                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                            </div>
                        </div>

                        <br>

                        <b-row>
                            <p>
                                La utilización de sustancias o compuestos químicos y sus derivados que se utilizan de 
                                manera directa, o a través de sus productos procedentes como plásticos, fibras sintéticas, 
                                pinturas, pegantes, tintas, pigmentos, insecticidas, combustibles, y otros, los cuales 
                                son parte del desarrollo y el bienestar de la empresa, toda vez que durante su procesamiento, 
                                almacenamiento, trasporte y uso pueden tener efectos contra la salud y la seguridad de las 
                                personas que los manejan y de la manera de almacenamiento, generando enfermedades laborales, 
                                accidentes de trabajo por contacto, incendios y explosiones. Por lo anterior, es esencial 
                                prevenir las enfermedades y accidentes causados por los productos químicos en el trabajo, 
                                por lo cual se deberá contar con lineamientos para el almacenamiento, transporte interno, 
                                uso, minimización y disposición final de los mismos, en concordancia con lo establecido por 
                                el Sistema Globalmente Armonizado (SGA) y la legislación colombiana vigente. 
                            </p>
                        </b-row>
                        
                        <br>

                        <b-row>
                            <b-col cols="4">

                                <b-list-group v-b-scrollspy:listgroup-ex>
                                    <b-list-group-item href="#list-item-1"
                                        >1. NORMATIVIDAD</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-2"
                                        >2. DEFINICIONES O GLOSARIO </b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-3"
                                        >3. CLASIFICACIÓN</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-4"
                                        >4. ETIQUETADO – ROTULO</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-5"
                                        >5. ALMACENAMIENTO DEL PRODUCTO QUÍMICO</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-6"
                                        >5.1. ASPECTOS A TENER EN CUENTA PARA EL ALMACENAMIENTO DE PRODUCTOS</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-7"
                                        >6. MANIPULACIÓN DE SUSTANCIAS QUÍMICAS</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-8"
                                        >7. RECOMENDACIONES EN CASO DE UNA EMERGENCIA QUÍMICA</b-list-group-item
                                    >
                                    <b-list-group-item href="#list-item-9"
                                        >8. DISPOSICIÓN FINAL</b-list-group-item
                                    >
                                </b-list-group>

                            </b-col>

                            <b-col cols="8">
                                <div id="listgroup-ex" style="position: relative; overflow-y: auto; height: 300px">

                                    <h4 id="list-item-1">Normatividad</h4>
                                        <p>
                                            Ley 9 de 1979: Art. 102, Congreso de la República Por la cual se dictan Medidas Sanitarias.
                                        </p>
                                        <p>
                                            Ley 55 de 1993: Art. 7, Art. 8, numeral 1, 12, 13, 15, 17, 18, Por medio de la cual se aprueba el "Convenio No. 170 
                                            y la Recomendación número 177 sobre la Seguridad en la Utilización de los Productos Químicos en el trabajo”, 
                                            adoptados por la 77a. Reunión de la Conferencia General de la O.I.T., Ginebra, 1990.
                                        </p>
                                        <p>
                                            Resolución 2400 de 1979. Estatuto de Seguridad Industrial. Título III Normas generales sobre riesgos, físicos, 
                                            químicos, biológicos en los establecimientos de trabajo. Capitulo X de las substancias infecciosas y tóxicas. Artículo 164.
                                        </p>
                                        <p>
                                            Decreto 1496 de 2018. El cual se adopta el Sistema Globalmente Armonizado de Clasificación y Etiquetado de Productos Químicos 
                                            y se dictan otras disposiciones en materia de seguridad química.  
                                        </p>
                                        <p>
                                            Resolución 773 de 2021 Por la cual se definen las acciones que deben desarrollar los empleadores para la aplicación 
                                            del Sistema Globalmente Armonizado (SGA) de Clasificación y Etiquetado de Productos Químicos en los lugares 
                                            de trabajo y se dictan otras disposiciones en materia de seguridad química  .
                                        </p>

                                    <br>

                                    <h4 id="list-item-2">Definiciones o glosario</h4>
                                        <p>
                                            Derrame: acumulación anormal de líquidos o gases en una cavidad natural o accidental.
                                        </p>
                                        <p>
                                            Equipo de Protección Personal (EPP): Es un conjunto de artefactos y accesorios, diseñados especialmente 
                                            para proteger el cuerpo del trabajador de los agentes a los cuales se expone con motivo o en ejercicio de su trabajo. 
                                            Así como cualquier equipo destinado a ser llevado o sujetado por el trabajador para que le proteja de uno o varios riesgos 
                                            que puedan amenazar su seguridad y salud. De los distintos tipos de E.P.P. se tiene: cascos, visores, lentes, antiparras, 
                                            máscaras o caretas, protectores auditivos, respiradores, guantes, botas de seguridad, cinturones, cuerda de seguridad,
                                            arnés de seguridad, etc., y otros dispositivos que se determinen y requieran de acuerdo al análisis de riesgos.  
                                        </p>
                                        <p>
                                            Etiqueta: Información impresa que advierte sobre un riesgo de una mercancía peligrosa, por medio de 
                                            colores o símbolos, la cual debe medir por lo menos 10 cm. X 10 cm., salvo en caso de bultos y cilindros,
                                            que debido a su tamaño solo puedan llevar etiquetas más pequeñas, se ubica sobre los diferentes empaques 
                                            o embalajes de las mercancías.  
                                        </p>
                                        <p>
                                            Ficha de datos de seguridad: Hoja de datos que nos brinda información detallada sobre los peligros de químicos específicos,
                                            como controlarlos y la seguridad que debemos tener. Material Safety Data Sheets.  
                                        </p>
                                        <p>
                                            Incompatibilidad: Es el proceso que sufren las mercancías peligrosas cuando puestas en contacto entre sí puedan sufrir 
                                            alteraciones de las características físicas o químicas originales de cualquiera de ellos con riesgo de provocar explosión, 
                                            desprendimiento de llamas o calor, formación de compuestos, mezclas, vapores o gases peligrosos, entre otros.  
                                        </p>
                                        <p>
                                            Plan de contingencia: Programa de tipo predictivo, preventivo y reactivo con una estructura estratégica, operativa e 
                                            informática desarrollado por la empresa, industria o algún actor de la cadena del transporte, para el control 
                                            de una emergencia que se produzca durante el manejo, transporte y almacenamiento de mercancías peligrosas, 
                                            con el propósito de mitigar las consecuencias y reducir los riesgos de empeoramiento de la situación y acciones. 
                                        </p>
                                        <p>
                                            Rótulos: Advertencia que se hace sobre el riesgo de una mercancía, por medio de colores y símbolos;
                                            se ubican sobre las unidades de transporte (contendores, carro tanques, entre otros).
                                        </p>
                                        <p>
                                            Sustancia Peligrosa: Sustancia o material, en cualquier cantidad o estado, que posee un
                                            riesgo potencial para la salud, seguridad y propiedad, que amenace las fuentes de agua y
                                            al medio ambiente cuando es transportado para su comercialización.  
                                        </p>
                                        <p>
                                            Tóxico (veneno): sustancias que puedan causar la muerte o lesiones graves o que pueden ser nocivas para la salud humana,
                                            si se ingieren o inhalan o entran en contacto con la piel. 
                                        </p>

                                    <br>

                                    <h4 id="list-item-3">Clasificación</h4>
                                        <p>
                                            Para la clasificación de las sustancias químicas se utiliza el Sistema 
                                            Globalmente Armonizado, reglamentado en Colombia por el Decreto 1496 de 2018: 
                                        </p>
                                        <img style="position: center;" width="700" height="400" src="@/assets/images/3clasificacion.png" />

                                    <br>

                                    <h4 id="list-item-4">Etiquetado - rotulo</h4>
                                        <p>
                                            Cada frasco, envase, garrafa, tambor, tanque o vasija que contenga cualquier tipo de sustancia química 
                                            debe estar debidamente etiquetado y con la identidad del producto químico que contiene como se muestra a continuación: 
                                        </p>
                                        <img style="position: center;" width="700" height="400" src="@/assets/images/etiqueta.png" />

                                    <br>

                                    <h4 id="list-item-5">Almacenamiento del producto químico</h4>
                                        <p>
                                            Se deben almacenar los productos químicos, ajustados a sus propiedades y características inherentes, que garanticen 
                                            la seguridad. Para esto se debe verificar en las fichas de seguridad las condiciones de almacenamiento y la Guía de normas. 
                                            En todas las áreas de almacenamiento debe estar expuesta La Matriz de Compatibilidad, fichas de seguridad, Kit de derrames, 
                                            extintor y dique con capacidad de contención del volumen del recipiente más 1.1 veces la capacidad almacenada y cartelera 
                                            con normas básicas para el manejo de las sustancias químicas. 
                                        </p>
                                        <p>
                                            El COPASST realizará inspección de las áreas de almacenamiento con el fin de evaluar las condiciones de seguridad de las mismas. 
                                        </p>
                                        <img style="position: center;" width="700" height="400" src="@/assets/images/tablaelementos.png" />
                                    <br>

                                    <h4 id="list-item-6">Aspectos a tener en cuenta para el almacenamiento de productos</h4>
                                        <ul>
                                            <li>
                                                Las condiciones de seguridad y vías de acceso adecuadas a las zonas de 
                                                almacenamiento deben estar libres fuentes de ignición.
                                            </li>
                                            <li>
                                                Se deben tener en cuenta todas las medidas de seguridad necesarias para minimizar emisiones,
                                                incendios, explosiones y reacciones químicas accidentales. 
                                            </li>
                                            <li>
                                                Los sitios donde se almacenan las sustancias deben cumplir unas características de temperatura,
                                                humedad y ventilación. Estas exigencias son especialmente importantes en casos en que la temperatura
                                                y la humedad ambientales son elevadas. Las exigencias relativas a la ventilación deberían impedir la
                                                acumulación de gases, vapores o humos en sitios encerrados.
                                            </li>
                                            <li>
                                                Estos recintos deben permanecer libres de comidas y bebidas.
                                            </li>
                                            <li>
                                                Debe existir extintor.
                                            </li>
                                            <li>
                                                Cuando se tenga que almacenar en arrumes debe ser clasificarse por tipo de envase,
                                                capacidad o similitud en pesos con el fin de evitar inconvenientes que puedan poner
                                                en riesgo la integralidad del personal que los manipula, perdida de materia prima
                                                almacenada y afectaciones al medio ambiente. 
                                            </li>
                                        </ul>
                                    <br>

                                    <h4 id="list-item-7">Manipulación de sustancias químicas</h4>
                                        <p>
                                            En las áreas de manipulación se tendrán los siguientes elementos, matriz de compatibilidad,
                                            fichas de seguridad, extintor, y sustancias debidamente etiquetadas.  
                                        </p>
                                        <p>
                                            Antes de manipular un producto químico infórmese con exactitud a qué tipo de sustancia se está exponiendo.
                                        </p>
                                        <p>
                                            Verifique que se esté usando la sustancia química apropiada para la tarea u operación.
                                        </p>
                                        <p>
                                            Determine la naturaleza o cualquier tipo de peligro de la sustancia a través de:
                                        </p>
                                        <ul>
                                            <li>
                                                Aislar efectivamente el peligro de exposición a la sustancia o sustancias químicas.
                                                (en la fuente, en el medio o en las personas). 
                                            </li>
                                            <li>
                                                La etiqueta o la información suministrada por la ficha de seguridad.
                                            </li>
                                            <li>
                                                Evita el contacto directo con cualquier sustancia química. Nunca oler,
                                                inhalar o saborear una sustancia química. 
                                            </li>
                                        </ul>
                                        <p>
                                            En las áreas de trabajo y almacenamiento, todo el personal se abstendrá de fumar, comer o beber.
                                        </p>
                                        <p>
                                            Estos recintos deben permanecer libres de comidas y bebidas.
                                        </p>
                                        <p>
                                            Use los elementos de protección personal necesarios para la manipulación. El equipo de protección
                                            personal se seleccionará dependiendo de la información suministrada por la ficha de seguridad: 
                                        </p>
                                        <img style="position: center;" width="700" height="400" src="@/assets/images/elementosproteccion.png" />
                                    <br>

                                    <h4 id="list-item-8">Recomendaciones en caso de una emergencia química</h4>
                                        <p>
                                            Las emergencias son eventos no planeados, los cuales pueden generar riesgos a la salud de los trabajadores,
                                            daños a la propiedad y al medio ambiente. Estas emergencias deben estar identificadas y contar con el Plan
                                            Operativo Normalizado, en el Plan de Prevención, Preparación y respuesta ante emergencias, ítem 5.1.1.
                                        </p>
                                    <br>

                                    <h4 id="list-item-9">Disposición final</h4>
                                        <p>
                                            La disposición final de los residuos derivados del almacenamiento, manipulación y uso de productos químicos 
                                            Los desechos que se generen por los envases y embalajes de las sustancias químicas, deben tener manejo 
                                            como residuo peligroso. Por lo tanto, su recolección, manejo, transporte y disposición final se debe realizar 
                                            a través de un gestor ambiental autorizado por la autoridad ambiental, que emita certificado de disposición 
                                            final adecuada de cada servicio realizado.
                                        </p>
                                </div>
                            </b-col>

                        </b-row>

                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>